<template>
  <div class="col-md-12 col-sm-12 col-xs-12">
    <div class="col-md-12 col-sm-12 col-xs-12">
      <div class="history-container">
        <div class="history-list">
          <div v-if="histories.length == 0" class="history-empty">
            <h4>Không có lịch sử cuộc gọi</h4>
          </div>
          <div v-else class="history-item" v-for="item in histories" :key="item.id">
            <div class="icon">
              <img v-if="item.direction === 'incoming'" src="../../assets/icon/incoming-call.png" alt="logo">
              <img v-if="item.direction === 'outgoing'" src="../../assets/icon/outgoing-call.png" alt="logo">
              <img v-if="item.direction === 'missed-call'" src="../../assets/icon/missed-call.png" alt="logo">
            </div>
            <div class="phone-number">
              <h3 class="dest-number">{{ item.dest_number }}</h3>
              <span class="call-date">{{ item.calldate | format_date }}</span>
            </div>
            <div class="info">
              <span class="duration">{{ convertSecondToMMSS(item.duration) }}</span>
              <div class="record-btn" v-show="item.record_url !== '' && item.record_url !== null" v-b-tooltip.hover title="Play" @click="play(item)">
                <i class="fa fa-play" aria-hidden="true"></i>
              </div>
            </div>
          </div>
          <div v-if="histories.length != 0">
            <infinite-loading @infinite="infiniteHandler">
              <div slot="no-more" class="mt-2">Không còn cuộc gọi nào</div>
              <div slot="no-results" class="mt-2">Không còn cuộc gọi nào</div>
            </infinite-loading>
          </div>
        </div>
      </div>
      <b-modal size='xl' id="playRecordModal" hide-footer title="Ghi âm cuộc gọi">
        <CallRecord :callRecord="currentRecord"></CallRecord>
      </b-modal>
    </div>
  </div>
</template>

<script>
import Box from '../../components/Box'
import InfiniteLoading from 'vue-infinite-loading'
import callCenterAPI from '../../api/callCenter'
import Utils from '../../common/utils'
import OrderApi from '../../api/orderApi'

export default {
  name: 'OrderCallHistory',
  components: {
    Box,
    InfiniteLoading
  },
  props: {
    orderId: {
      type: Number,
      required: false
    }
  },
  data () {
    return {
      histories: [],
      page: 0,
      page_size: 100,
      loading: true,
      phone_number: false,
      currentRecord: null,
    }
  },
  mounted () {
    if (this.orderId) {
      this.getHistoryList()
    }
  },
  watch: {
    currentPage: {
      handler: function () {
        this.filter()
      }
    },
    pageSize: {
      handler: function () {
        this.filter()
      }
    }
  },
  methods: {
    async getHistoryList () {
      this.loading = true
      try {
        const orderDetail = (await OrderApi.get(this.orderId)).data.data
        this.phone_number = orderDetail.customer.phone
        const res = await callCenterAPI.get_user_call_history(0, this.page_size, this.phone_number)
        this.loading = false
        if (res.data && res.data.data) {
          this.histories = res.data.data.records
        }
      } catch (err) {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      }
    },
    convertSecondToMMSS (second) {
      return Utils.convertSecondToMMSS(second)
    },
    reload () {
      this.getHistoryList()
    },
    play (item) {
      this.currentRecord = item
      this.$bvModal.show('playRecordModal')
    },
    infiniteHandler ($state) {
      this.loading = true
      this.page = this.page + 1
      callCenterAPI.get_user_call_history(this.page, this.page_size, this.phone_number).then(res => {
        this.loading = false
        if (res.data && res.data.data && res.data.data.records.length > 0) {
          this.histories.push(...res.data.data.records)
          $state.loaded()
        } else {
          $state.complete()
        }
      }).catch(err => {
        this.loading = false
        Utils.handleError(this.$bvToast, err)
      })
    }
  },
}
</script>

<style scoped>
  .history-container {
    border-left: none;
  }
</style>



// WEBPACK FOOTER //
// src/views/order_management/OrderCallHistory.vue